import React from 'react';
import { ghostIconButton } from './chatViewTheme';

export default function ChatIconButton({ onClick, label, title, children, className = '' }: any) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${ghostIconButton} ${className}`.trim()}
      aria-label={label}
      title={title || label}
    >
      {children}
    </button>
  );
}
